import * as React from 'react';
import { PulseLoader } from "react-spinners";

interface ILoaderProps {
  loading: boolean
}
export const Loader: React.FunctionComponent<ILoaderProps> = (props) => {
  return (
    <div className="help-loader-sidebar">
      <PulseLoader
        size={20}
        color={"#1A757D"}
        loading={props.loading}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/Alert/Create/components/Loader.tsx